import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppBack } from '../../hooks/useAppBack';
import { useAuth } from '../../hooks/useAuth';
import { SettingsPageHeader } from './SettingsPageHeader';
import { IoCardOutline } from 'react-icons/io5';
import { SubscriptionPanel } from '../../components/SubscriptionPanel';

export function MobileSubscriptionSettingsPage() {
  const { t } = useTranslation();
  const { user, refreshProfile } = useAuth();
  const goBack = useAppBack('/settings');
  return <div className="mobile-screen mobile-settings-screen">
    <SettingsPageHeader title={t(user?.role === 'coach' ? 'subscription.coachTitle' : 'subscription.title')}
       icon={IoCardOutline} onBack={goBack} />
    {user && <SubscriptionPanel key={user.id} user={user} onActivated={refreshProfile} />}
  </div>;
}
